import { render } from "./HeaderSauron.vue?vue&type=template&id=166eb4d0&scoped=true"
import script from "./HeaderSauron.vue?vue&type=script&lang=js"
export * from "./HeaderSauron.vue?vue&type=script&lang=js"

import "./HeaderSauron.vue?vue&type=style&index=0&id=166eb4d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166eb4d0"]])

export default __exports__